import { createTheme } from '@mui/material/styles';
import { sharedColors, sharedFonts } from './shared.styles';

export const customTheme = createTheme({
  palette: {
    background: { default: sharedColors.bgMain },
  },
  typography: {
    fontFamily: sharedFonts.main,
    allVariants: {
      fontFamily: sharedFonts.main,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontFamily: sharedFonts.main,
        },
        body: {
          fontFamily: sharedFonts.main,
        },
        'button, input, textarea, select': {
          fontFamily: 'inherit',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: sharedFonts.main,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: sharedFonts.main,
        },
      },
    },
  },
});
